import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';
import linkstate from 'linkstate';
import md5 from 'crypto-js/md5';

import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import ImageScroller from '../../components/imagescroller';
import HelpText from '../../components/gui/helpText';
import Input from '../../components/form/input';

import localUtil from '../../lib/util';

function participantExists(participants, key, value) {
    return participants.some(participant => participant[key] === value);
}

@observer
class ConventionSignup extends Component {
  	constructor(props) {
        super(props);
        this.state = {

        };
    }

    updateField = async (e) => {
        const { id, md5, stage } = this.props;
        const { value, name, type } = e.target;
        const { field } = e.target.dataset;
        // console.log('updateClass', value);
        const { conventionStore } = this.props.stores;
        await conventionStore.editArrayObject({
            field,
            key: name,
            value,
            id,
            md5,
        });
    }

    render() {
        const { id, idx, md5, stage, drawerLevel = 1 } = this.props;
        const { appState, userStore, conventionStore } = this.props.stores;
        const { user = {}, isAdmin, isTester, isVeterinary, language } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const stageNumber = parseInt(idx, 10) + 1;
        const stageParticipantFieldName = `participants${stageNumber}`;
        const sections = fields.get('convention', 'convention settings', [], [stageParticipantFieldName]);

        const { convention } = conventionStore;
        const currentStage = convention.stages.find(s => s.md5 === md5);
        const stageFieldName = `stages`;

        const stageDone = currentStage.stageDone == 1;
        const stageClosed = currentStage.stageClosed == 1;

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100 h-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                    <div class={`font-weight-lighter px-3 mt-3 box-header w-100 position-relative`}>
                        {convention.title}
                    </div>
                    {/* id: {id}<br /> */}
                    {/* md5: {md5}<br /> */}
                    {/* stage: {stage}<br /> */}
                    {/* participantFieldName: {participantFieldName}<br /> */}
                    {/* <xmp>{JSON.stringify(currentStage, null, 2)}</xmp> */}
                    {/* <xmp>{JSON.stringify(currentParticipant, null, 2)}</xmp> */}

                    <div class='w-100 d-flex flex-column'>
                        <div class='px-0 box-header-info d-flex flex-column'>
                            <div class={`d-flex flex-column mt-3 mx-3 px-3 py-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                                <div class='d-flex flex-column'>
                                    <span class='text-muted font-weight-light'>
                                        <Text id='convention.stage'>Stage</Text>
                                    </span>
                                    <span>
                                        {stageNumber}: {currentStage.name}
                                    </span>
                                    {stageDone ? <>
                                        <span class='badge text-bg-success font-weight-normal rounded-pill' style={`font-size: 1.2em;`}>
                                            <Text id='convention.stage-done'>Stage done</Text>
                                        </span>
                                        {/* {stageClosed ? <>
                                            Closed
                                        </> : <>
                                            Not closed
                                        </>} */}
                                    </> : <>
                                        {stageClosed ? <>
                                            <span class='badge text-bg-warning font-weight-normal rounded-pill' style={`font-size: 1.2em;`}>
                                                <Text id='convention.stage-upcoming'>Stage not started</Text>
                                            </span>
                                        </> : <>
                                            <span class='badge text-bg-danger font-weight-normal rounded-pill' style={`font-size: 1.2em;`}>
                                                <Text id='convention.stage-running'>Stage running</Text>
                                            </span>
                                        </>}
                                    </>}
                                </div>
                                <div class='d-flex flex-column mt-3'>
                                    <span class='text-muted font-weight-light'>
                                        <Text id='convention.choose-class'>Choose stage type</Text>
                                    </span>
                                    <select
                                        class='form-control rounded-pill'
                                        onInput={this.updateField}
                                        name={'type'}
                                        value={currentStage.type}
                                        data-field={stageFieldName}
                                    >
                                        <option value=''>-- Choose type --</option>
                                        <option value='nais'>NAIS</option>
                                        <option value='hurtig'>Hurtig</option>
                                        <option value='hurtig-half'>Hurtig halv serie</option>
                                        <option value='standard'>Standard</option>
                                        <option value='felt'>Felt</option>
                                        <option value='norgesfelt'>Norgesfelt</option>
                                        <option value='t-96'>T-96</option>
                                        <option value='finpistol'>VM-Finpistol</option>
                                        <option value='grovpistol'>VM-Grovpistol</option>
                                        <option value='silhuett'>Silhuettpistol</option>
                                        <option value='luftpistol'>Luftpistol 10m</option>
                                        <option value='griseskyting'>Griseskyting</option>
                                        <option value='skarpskytter'>Skarpskyttermerke</option>
                                        <option value='tidsoving'>Tidsøvelse</option>
                                        <option value='tidskonk'>Tidskonkurranse</option>
                                        <option value='fri'>Fri (poeng)</option>
                                    </select>
                                </div>
                                <div class='d-flex flex-column mt-3'>
                                    <span class='text-muted font-weight-light'>
                                        <Text id='convention.stage-slots'>Number of slots</Text>
                                    </span>
                                    <input
                                        class='form-control rounded-pill'
                                        onInput={this.updateField}
                                        name={'stageSlots'}
                                        value={currentStage.stageSlots}
                                        type='number'
                                        data-field={stageFieldName}
                                    />
                                </div>
                                <div class='d-flex flex-column mt-3'>
                                    <span class='text-muted font-weight-light'>
                                        <Text id='convention.stands'>Number of stands</Text>
                                    </span>
                                    <input
                                        class='form-control rounded-pill'
                                        onInput={this.updateField}
                                        name={'stages'}
                                        value={currentStage.stages}
                                        type='number'
                                        data-field={stageFieldName}
                                        disabled={currentStage.type === 't-96'}
                                    />
                                    {currentStage.type === 't-96' && (
                                        <small class='text-body-secondary mt-1'>
                                            <Text id='convention.t96-fixed-stages-help'>Fixed 16 series for T-96</Text>
                                        </small>
                                    )}
                                </div>
                                <div class='d-flex flex-column mt-3'>
                                    <span class='text-muted font-weight-light'>
                                        <Text id='convention.stage-time'>Stage date and time</Text>
                                    </span>
                                    <input
                                        class='form-control rounded-pill'
                                        onInput={this.updateField}
                                        name={'date'}
                                        value={util.isoDate(currentStage.date)}
                                        type='datetime-local'
                                        data-field={stageFieldName}
                                    />
                                </div>
                                <div class='d-flex justify-content-between mt-3'>
                                    <div class='flex-grow-1 ps-2 pe-2'>
                                        <span class='text-muted font-weight-light'>
                                            <Text id='convention.stage-closed'>Stage closed</Text>
                                        </span>
                                        {/* <xmp>{JSON.stringify(currentStage.stageClosed, null, 2)}</xmp> */}
                                    </div>
                                    <div class='form-check custom-switch custom-switch-lg d-flex justify-content-end me-3'>
                                        <input
                                            type='checkbox'
                                            id={`stageClosedInputToggle`}
                                            class='inputForm form-check-input'
                                            name={'stageClosed'}
                                            value={currentStage.stageClosed == 1 ? 0 : 1}
                                            data-field={stageFieldName}
                                            onInput={this.updateField}
                                            checked={currentStage.stageClosed == 1 ? 'checked' : ''}
                                            autocomplete={'off'}
                                        />
                                        <label class='form-check-label ps-2' for={`stageClosedInputToggle`} />
                                    </div>
                                </div>
                                <div class='d-flex justify-content-between mt-3'>
                                    <div class='flex-grow-1 ps-2 pe-2'>
                                        <span class='text-muted font-weight-light'>
                                            <Text id='convention.stage-done'>Stage done</Text>
                                        </span>
                                    </div>
                                    <div class='form-check custom-switch custom-switch-lg d-flex justify-content-end me-3'>
                                        <input
                                            type='checkbox'
                                            id={`stageDoneInputToggle`}
                                            class='inputForm form-check-input'
                                            name={'stageDone'}
                                            value={currentStage.stageDone == 1 ? 0 : 1}
                                            data-field={stageFieldName}
                                            onInput={this.updateField}
                                            checked={currentStage.stageDone == 1 ? 'checked' : ''}
                                            autocomplete={'off'}
                                        />
                                        <label class='form-check-label ps-2' for={`stageDoneInputToggle`} />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class={`font-weight-lighter px-3 mt-3 box-header w-100 position-relative`}>
                        <Text id='convention.participant'>Participants</Text>
                    </div>

                    <FormFieldsCompact
                        stores={this.props.stores}
                        sections={sections}
                        holdingStore={conventionStore}
                        objectName={'convention'}
                        isNew={false}
                        drawerLevel={drawerLevel}
                        isAdmin={false}
                        hideAdmin={true}
                        showSectionName={false}
                        marginTop={'mt-0'}
                    />

                    {/* <SimpleBlog stores={this.props.stores} {...this.props} /> */}
                </div>
            </div>
        </>);
    }
}

export default ConventionSignup;
